import { IQuery, ICommand, IQueryMediator, IDefineCommand } from 'core-ts-types';
import { ITransferExamTypesDatasource } from '../datasources/transfer_exam_types_datasource';

angular.module('capability-ng-transfer').factory(
  'loadTransferExamTypeCommand',
  (
    defineCommand: IDefineCommand,
    $http: ng.IHttpService,
    QueryMediator: IQueryMediator,
    ngTransferExamTypesDatasource: ITransferExamTypesDatasource
  ): ICommand => {
    return defineCommand('loadTransferExamTypeCommand', (deferred: ng.IDeferred<IQuery[]>): void => {
      $http
        .get('catalog/exam-type/')
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          ngTransferExamTypesDatasource.clear();
          ngTransferExamTypesDatasource.write(response.data.results);

          deferred.resolve(QueryMediator.runQueries(ngTransferExamTypesDatasource));
        })
        .catch((error: any): void => {
          deferred.reject(error);
        });
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_exam_types_command.ts